import React, { useEffect, createElement } from 'react';
import { PlannerBundlePage } from './pages/PlannerBundlePage';
export function App() {
  useEffect(() => {
    // Verificar si el pixel ya está inicializado
    if ((window as any).fbq) {
      console.log('Meta Pixel already loaded');
      return;
    }
    // Meta Pixel Code
    ;
    (function (f: any, b: Document, e: string, v: string) {
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      // Safely insert script into document
      const firstScript = b.getElementsByTagName(e)[0] as HTMLScriptElement;
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
    // Initialize Meta Pixel - PageView se trackea automáticamente
    ;
    (window as any).fbq('init', '1420953519696835');
    // Add noscript fallback image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1420953519696835&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <PlannerBundlePage data-id="element-0" />;
}